import Modal from "components/common/Modal";
import React, {
  createContext,
  FC,
  ReactNode,
  SetStateAction,
  useCallback,
  useState,
} from "react";
import { useNavigate } from "react-router-dom";
import {
  IModalContext,
  IModalProviderProps,
  IModalSize,
} from "types/context/modal";

export const ModalContext = createContext({} as IModalContext);

const ModalProvider: FC<IModalProviderProps> = ({ children }) => {
  const [modalContent, setModal] = useState<ReactNode>(null);
  const [modalSize, setModalSize] = useState<IModalSize>("lg");
  const [redirectOnClose, setRedirectOnClose] = useState("");
  const [style, setStyle] = useState({});
  const [onClose, setOnClose] = useState<() => void>();

  const navigate = useNavigate();

  const showModal = useCallback(
    (
      content: ReactNode,
      size?: IModalSize,
      redirect?: SetStateAction<string>,
      styleProp?: any,
      onClose?: () => void
    ) => {
      setModal(content);
      if (size) setModalSize(size);
      if (redirect) setRedirectOnClose(redirect);
      if (styleProp) setStyle(styleProp);
      if (onClose) setOnClose(onClose);
    },
    [setModal]
  );

  const hideModal = useCallback(() => {
    setModal(null);
    setModalSize("lg");
    setStyle({});
    if (redirectOnClose) {
      navigate(redirectOnClose);
    }
    if (onClose) {
      onClose();
    }
  }, []);

  return (
    <ModalContext.Provider
      value={{ showModal, hideModal, open: !!modalContent, modalSize, style }}
    >
      {children}
      <Modal>{modalContent}</Modal>
    </ModalContext.Provider>
  );
};

export default ModalProvider;
